//question
export default {
    styles: {
        block: {
            maxWidth: 250,
        },
        radioButton: {
            marginBottom: 16,
        },
    },
    textStyle: {
        fontFamily: "franklin-gothic-urw-comp, sans-serif",
        color: 'black'
    },
    style: {
        textAlign: 'center',
        color: 'black'
    },
    style2: {
        width: '90px',
    },
    hide: {
        display: 'none',
    },
    content: {
        marginLeft: '39px',
    },
    textStyle2: {
        fontFamily: "franklin-gothic-urw-comp, sans-serif",
        color: '#F27935',
        textAlign: 'center',
        width: '100%',
        fontSize: '15px'
    },
    textStyle3: {
        fontFamily: "franklin-gothic-urw-comp, sans-serif",
        color: '#F27935',
        textAlign: 'center',
        width: '100%',
        fontSize: '25px'
    },
    textStyle4: {
        fontFamily: "franklin-gothic-urw-comp, sans-serif",
        textAlign: 'left',
        width: '100%',
        fontSize: '15px',
        marginLeft: '20px'
    },
    output: {
        display: 'flex',
        width: '100%',
        //height: '100vh',
        alignItems: 'center',
        textAlign: 'center'
    }
}


// WEBPACK FOOTER //
// ./styles/inline.css.js